export const CATALOG_MAIN_LINK = 'catalog'
export const CATALOG_ITEM_LINK = 'item'
export const CART_MAIN_LINK = 'cart'
export const USER_AGREEMENT_LINK = 'user-agreement'
export const PRIVACY_POLICY_LINK = 'privacy-policy'
export const STATIC_DOCS_LINK = 'docs'
export const SEARCH_PAGE = 'search'
export const ABOUT_PAGE = 'about-us'

export const MAIN_URL = "https://app.sanywatches.com/public";
// export const MAIN_URL = "https://sellone-backend.cabatest.ru/public";

export const DEV_SHOP_ID = "67639189fd2e8b810942df8b"

export const PHONE = '+7 925 114-50-54'
export const EMAIL = 'neplaneta@gmail.com'
export const ARTICL_NAME = 'Product ID'
export const RECENTLY_VIEW_LS_KEY = 'recently-view'
export const POSSIBLE_CONDITION = [
    ' Brand New, 2024 Model',
    'Perfect Condition',
    'Like New',
    'New with Original Packaging',
    'Pre - owned, Excellent Condition',
    'Very Good Condition',
    'Good Condition',
    'Lightly Used',
    'With Minor Signs of Use',
    'Requires Repair',
    'Restored',
    `Limited Edition`,
    `Collector's Condition`,
    `Used, Verified`,
    `Previous Owner's Condition`,
    `Packaged for Sale`,
    `Certified Condition`,
    `Exclusive Condition`,
    `Tested and Guaranteed`,
    `Vintage Condition`,
    `Rare Item`,
    `With Usage, Fully Functional`,
    `With Upgraded Components`,
    `No Signs of Use`,
    `Display Model`,
    `With Original Documents`,
    `With Additional Accessories`,
    `Serviced`,
    `With Authenticity Guarantee`,
    `Authenticity Verified`,
]

export const CURRENCY_MAP = {
    'USD': '$',  // United States Dollar
    'EUR': '€',  // Euro
    'JPY': '¥',  // Japanese Yen
    'GBP': '£',  // British Pound
    'AUD': 'A$', // Australian Dollar
    'CAD': 'C$', // Canadian Dollar
    'CHF': 'CHF', // Swiss Franc
    'CNY': '¥',  // Chinese Yuan
    'SEK': 'kr',  // Swedish Krona
    'NZD': 'NZ$', // New Zealand Dollar
    'MXN': '$',  // Mexican Peso
    'SGD': 'S$', // Singapore Dollar
    'HKD': 'HK$', // Hong Kong Dollar
    'NOK': 'kr',  // Norwegian Krone
    'KRW': '₩',  // South Korean Won
    'TRY': '₺',  // Turkish Lira
    'INR': '₹',  // Indian Rupee
    'RUB': '₽',  // Russian Ruble
    'BRL': 'R$', // Brazilian Real
    'ZAR': 'R',  // South African Rand
    'USDT': 'USDT',  // South African Rand
};


export const IMG_PLACEHOLDER_PRODUCT = 'https://app.sanywatches.com/get-file/public/additional_data/product-placeholder.png'
export const IMG_PLACEHOLDER_PROMO = 'https://app.sanywatches.com/get-file/public/additional_data/promo-placeholder.png'
export const LANDING_URL = 'https://sanywatches.com'

export const DEMO_PRODUCT = {
    "_id": "65ac892aca48bfd1dbd637a2",
    "name": "Demo Product",
    "description": "Demo Descript",
    "options": [
        {
            "name": "3",
            "values": [
                {
                    "value": "3",
                    "price_raise": null,
                    "in_stock": null
                },
                {
                    "value": "4",
                    "price_raise": null,
                    "in_stock": null
                }
            ]
        },
        {
            "name": "4",
            "values": [
                {
                    "value": "3",
                    "price_raise": null,
                    "in_stock": null
                }
            ]
        }
    ],
    "price_data": {
        "price": "123323",
        "discount": 2,
        "in_stock": 10
    },
    "categories": [
        {
            "_id": "65ad0632ca48bfd1dbd637d2",
            "name": "new",
            "translit_name": "new-z9qX",
            "count": 1,
            "is_final": true,
            "parents": [
                {
                    "_id": "65ad0632ca48bfd1dbd637d2",
                    "name": "new",
                    "translit_name": "new-z9qX",
                    "count": 1,
                    "is_final": true
                },
                {
                    "_id": "65acfbe4ca48bfd1dbd637ab",
                    "name": "1",
                    "translit_name": "1-cI5U",
                    "count": 8,
                    "is_final": false
                },
                {
                    "_id": "65ac86cbca48bfd1dbd63794",
                    "name": "Диван кровать",
                    "translit_name": "test-4RPc",
                    "count": 4,
                    "is_final": false
                }
            ]
        },
        {
            "_id": "65acfbecca48bfd1dbd637ad",
            "name": "test",
            "translit_name": "test-kS5l",
            "count": 2,
            "is_final": true,
            "parents": [
                {
                    "_id": "65acfbecca48bfd1dbd637ad",
                    "name": "test",
                    "translit_name": "test-kS5l",
                    "count": 2,
                    "is_final": true
                },
                {
                    "_id": "65ac86cbca48bfd1dbd63794",
                    "name": "Диван кровать",
                    "translit_name": "test-4RPc",
                    "count": 4,
                    "is_final": false
                }
            ]
        }
    ],
    "files": [
        {
            "_id": "65acf9d0ca48bfd1dbd637a5",
            "expire_at": null,
            "urls": {
                "orig": IMG_PLACEHOLDER_PRODUCT,
                // "orig": 'https://placehold.co/100x100',

            }
        }
    ]
}




export const ACTIVITY_PING_TIMEOUT = 5000

export const OWN_DELIVERY_TYPE = 'own_delivery'
export const NO_DELIVERY_TYPE = 'no_delivery'
export const DELIVERY_TYPE_VALUES =
{
    [OWN_DELIVERY_TYPE]: 'Delivery',
    [NO_DELIVERY_TYPE]: 'Pickup',
}

export const WATCHES_CATEGORY_LINK = 'watches'
export const JEWELRY_CATEGORY_LINK = 'jewelry'
export const HERMES_BAGS_CATEGORY_LINK = 'hermes-bags'
export const FINE_ART_CATEGORY_LINK = 'fine-art'
export const ABOUT_US_PAGE_LINK = 'about-us'
export const SELL_TO_US_PAGE_LINK = 'sell-to-us'
export const NEW_CATEGORY_LINK = 'new-arrivals'
export const SPECIAL_CATEGORY_LINK = 'special-offers'

export const CONTACT_PHONE = {
    value:'+971564371818',
    formated: '+971 56 437 1818'
}

export const RU_SITE_URL = "https://sanywatches.ru"
export const EN_SITE_URL = "https://sanywatches.com"